// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopPaymentRequestModel from '../../model/get-shop-payment-request-model';
import GetShopPaymentRequestDTO from '../dto/get-shop-payment-request-dto';
import dtoSchema from '../schemas/get-shop-payment-request-schema';

export default abstract class GetShopPaymentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopPaymentRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopPaymentRequestDTO>): GetShopPaymentRequestModel;
  static toModel(dto: DeepPartial<GetShopPaymentRequestDTO> | undefined | null): GetShopPaymentRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopPaymentRequestDTO> | undefined | null): GetShopPaymentRequestModel | undefined {
    return dto ? new GetShopPaymentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopPaymentRequestModel> | GetShopPaymentRequestModel): GetShopPaymentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopPaymentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopPaymentRequestModel, can not map to GetShopPaymentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
